<template>
  <div style="overflow-y: hidden; height: 100%">
    <app-base-main parentTable v-show="mainVisible && !showDetail">
      <template #filter-group>
        <app-filter-group :fixWidth="200" @reset="$gjReset" @query="$gjNoticeQuery">
          <gj-country-server-select
              v-model="filter.countryMarketValue"
          ></gj-country-server-select>
          <gj-select
              v-model="filter.statuses"
              :options="reviewOption ? statusOption.open : statusOption.close"
              type="multi-check"
              :width="clientWidth>1366?'160px':'160px'"
              placeholder="全部状态"
          ></gj-select>
          <gj-warehouse-select
              :fba="false"
              multiple
              v-model="filter.warehouseIds"
              placeholder="发货仓库"
              :width="clientWidth>1366?'190px':'190px'"
          ></gj-warehouse-select>
          <gj-select-date-picker
              type="daterange"
              v-model="filter.date"
              :options="[
              { id: 'created', text: '创建时间' },
              { id: 'deliver', text: '发货时间' },
            ]"
              :width="clientWidth>1366?['100px', '210px']:['95px', '200px']"
          ></gj-select-date-picker>
          <gj-select-input
              v-model="filter.keyword"
              :options="keywordList"
              :width="clientWidth>1366?['110px', '150px']:['110px', '100px']"
          ></gj-select-input>
          <template #advancedFilter>
            <gj-select
                v-model="filter.areCasesRequired"
                :options="FbaShipmentEnum.areCasesRequiredOption"
                placeholder="包装类型"
            ></gj-select>
            <gj-select
                v-model="filter.relationTransfer"
                :options="FbaShipmentEnum.transferSlipOption"
                placeholder="关联调拨单"
                width="120px"
            ></gj-select>
            <gj-select
                v-model="filter.relationShipment"
                :options="FbaShipmentEnum.associatedGoodsOption"
                placeholder="关联货件"
            ></gj-select>
          </template>
          <template #right>
            <view-setting
                :ref="REF_VIEW_SETTING"
                save-mode="remote"
                :use-default="true"
                :module-name="moduleName"
                :config="model"
                :fn-generate-params="generateViewParams"
                @view-change="handleChangeView"
                @view-complete="handCompleteView"
            >
            </view-setting>
          </template>
        </app-filter-group>
      </template>
      <template #operate-group>
        <template v-if="$permission('shipPlan:add')">
          <gj-button type="primary" @click="add">添加</gj-button>
          <gj-select
              class="selected-active"
              v-model="batchOperate"
              :options="reviewOption ? operateOptions.open : operateOptions.close"
              @input="changeOperate"
              placeholder="批量操作"
              :clearable="false"
              width="100px"
          ></gj-select>
          <gj-button :loading="btnLoading.generatePurchasePlan" @click="addPurchasePlan"
                     v-if="$permission('shipPlan:generatePurchasePlan')">生成采购计划
          </gj-button>
          <gj-button :loading="btnLoading.generateTransfer" @click="addTransferSlip"
                     v-if="$permission('shipPlan:generateTransfer')">生成调拨单
          </gj-button>
          <gj-button :loading="btnLoading.generateShipment" @click="addPackage"
                     v-if="$permission('shipPlan:generateShipment')">创建货件
          </gj-button>
          <gj-button v-if="$permission('shipPlan:printLabels')" @click="printLabel">打印商品标签</gj-button>
        </template>

      </template>
      <template #tool-group>
        <div style="margin-right: 10px;font-size: 12px;color: #333333;font-weight: 400;">
          <span :class="{'gj-group':true,'group-active':groupType === 'marketId'}"
                @click="changeGroup('marketId')">按店铺分组</span>
          <span>|</span>
          <span :class="{'gj-group':true,'group-active':groupType === 'planBatchCode'}"
                @click="changeGroup('planBatchCode')">按批次分组</span>
        </div>
        <gj-tool-group
            :download="$permission('shipPlan:export')"
            download-url="/supply/shipPlan/export"
            :download-params="globalParams"
            :sort-gjtable="$refs.gjTable"
            help
            setting
            :table-name="tableName"
            :table-columns="columns"
        ></gj-tool-group>
      </template>
      <template #table>
        <gj-table
            ref="gjTable"
            adaptParent
            :index="false"
            :name="tableName"
            :loading="loading"
            :data="tableData"
            :columns="columns"
            selection
            :scroll-x="{gt: -1}"
            :scroll-y="{gt: -1}"
            :selectable="selectable"
            :bak-selected-rows="bakSelectedRows"
            @clearBakSelectedRows="clearBakRows"
            @openDetail="openDetail"
            :expandRowVisible="true"
            :bak-rows="selectedRows"
            :child-selection="true"
            :extend-row-config="{prop: 'extendRow'}"
            :structure-config="{type: 'ParentChild', children: 'shipPlanList', parentSpan: [1, 14]}"
            sortable="custom"
            :pagination="pagination"
            :show-overflow="false"
            :default-sort="{prop: 'createTime', order: 'descending'}"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery">
          <template v-slot:code="{row}">
            <template v-if="row.$gjParentData && groupType === 'planBatchCode'">
                <span style="display: inline-block;width: 190px">
                   <span class="title-span">批次号：</span><span><gj-button type="text" @click="openLog(row)">{{
                    row.planBatchCode | defaultShow
                  }}</gj-button></span>
                </span>
              <span style="display: inline-block;width: 150px">
                 <span class="title-span">创建人：</span><span>{{ row.createUserName | defaultShow }}</span>
              </span>
              <span style="display: inline-block;width: 240px">
                <span class="title-span">创建时间：</span><span>{{ row.createTime | defaultShow }}</span>
              </span>
              <span style="display: inline-block;width: 300px">
                 <app-delivery-plan-desc
                     :value="row.memo"
                     :item="row"
                     :prefixText="'备注：'"
                     :show-prefix="true"
                     fixedIcon
                     table-cell-edit
                     :on-confirm="confirmEditMemo"
                     :pop-title="'备注编辑'">
                  </app-delivery-plan-desc>
               </span>
            </template>
            <template v-if="row.$gjParentData && groupType === 'marketId'">
                <span style="display: inline-block;cursor:pointer;width: 20px;height: 20px">
                  <i class="el-icon-arrow-right" v-if="!row.childVisible" @click="openAll(row,true)"></i>
                  <i class="el-icon-arrow-down" v-if="row.childVisible" @click="openAll(row,false)"></i>
                </span>
              <span style="display: inline-block;width: 240px">
                    <span class="title-span">店铺：</span><span style="white-space: normal;">{{ row.marketName ? row.marketName + ':' + row.countryCode + `(${row.num})` : '-' }}</span>
                </span>
              <span style="display: inline-block;width: 150px">
                    <span class="title-span">计划发货量：</span><span>{{ row.shipedPlanQuantity | defaultShow }}</span>
                </span>
              <span style="display: inline-block;width: 80px">
                    <span class="title-span">箱数：</span><span>{{ row.packageQuantity | defaultShow }}</span>
                </span>
              <span style="display: inline-block;width: 120px">
                    <span class="title-span">总体积：</span><span>{{ row.totalCapacity | defaultShow }}m³</span>
                </span>
              <span style="display: inline-block;width: 150px">
                    <span class="title-span">体积重：</span><span>{{ row.volumeWeight | defaultShow }}kg</span>
                </span>
              <span style="display: inline-block;width: 120px">
                    <span class="title-span">总净重：</span><span>{{ row.totalNetWeight | defaultShow }}kg</span>
                </span>
              <span style="display: inline-block;width: 120px">
                    <span class="title-span">总毛重：</span><span>{{ row.grossWeight | defaultShow }}kg</span>
                </span>
              <span style="display: inline-block;width: 180px">
                    <span class="title-span">总货值(估值)：</span><span>￥{{ row.totalValue | defaultShow }}</span>
                </span>
            </template>
            <template v-if="row.$gjChildData">
              <gj-button type="text" @click="shipPlanView(row)">{{ row.code }}</gj-button>
              <!-- <span v-if="row.productType === 'Assembly'" class="type-text">组</span> -->
              <gj-tag v-if="row.productType === 'Assembly'" type="dark" :color="tagColors.blueDark">组</gj-tag>
            </template>
          </template>
          <template v-slot:msku="{ row }">
            <template v-if="row.$gjChildData">
              <div>
                <gj-text width="90%">{{ row.msku }}</gj-text>
              </div>
              <div>
                <gj-text width="90%">{{ row.fnsku }}</gj-text>
              </div>
            </template>
          </template>
          <template v-slot:productName="{ row }">
            <template v-if="row.$gjChildData">
              <div>
                <gj-text width="90%">{{ row.productName }}</gj-text>
              </div>
              <div>
                <span>{{ row.sku }}</span>
              </div>
            </template>
          </template>
          <template v-slot:countryCode="{row}">
            <template v-if="row.$gjChildData">
              <span>{{ row.marketName }}:{{ row.countryCode }}</span>
            </template>
          </template>
          <template v-slot:availableQuantity="{ row }">
            <template v-if="row.$gjChildData">
              <div style="display: flex;">
              <span>
                  {{ row.availableQuantity | defaultShow }};&nbsp;{{ row.alreadyOrderQuantity | defaultShow }};
              &nbsp;{{ row.planWarehouseQuantity | defaultShow }}
              </span>
                <gj-popover trigger="hover" placement="bottom" width="600"
                            v-if="row.productType=== 'Assembly' && row.warehouseId">
                  <template>
                    <div>
                      <div class="maxNum">
                        <div>最大装配量：<span style="color: #EFA621;">{{ maxTableDataVo.maxAssemblyQuantity }}</span></div>
                      </div>
                      <gj-table
                          :columns="maxNumColumns"
                          ref="gjTable2"
                          :index="false"
                          name="maxNumTable"
                          :data="maxTableDataVo.voList"
                          :loading="maxLoading"
                          :size="'has-picture'"
                          :adapt-height="false"
                          :height="300"
                      >
                        <template v-slot:skuName="{row}">
                          <gj-text width="90%">{{ row.productName }}</gj-text>
                          <br>
                          <gj-text width="90%">{{ row.sku }}</gj-text>
                          <br>
                        </template>
                      </gj-table>
                    </div>
                  </template>
                  <div slot="reference" style="margin-left: 5px;color: #1F6EEF;">
                    <i class="el-icon-connection" @mouseover="getMaxNums(row.sku, row.warehouseId)"></i>
                  </div>
                </gj-popover>
              </div>
            </template>
          </template>
          <template v-slot:shipPlanShipments="{ row }">
            <template v-if="!row.$gjParentData">
              <template v-if="row.shipPlanShipments && row.shipPlanShipments.length !== 0">
                <el-dropdown>
                   <span class="el-dropdown-link" style="font-size: 12px">
                    <span>
                      {{
                        row.shipPlanShipments[0] && row.shipPlanShipments[0].shipmentId
                      }} | {{ row.shipPlanShipments && row.shipPlanShipments[0].quantity }}
                      <i class="el-icon-arrow-down el-icon--right" v-if="row.shipPlanShipments.length > 1"></i></span>
                   </span>
                  <el-dropdown-menu slot="dropdown">
                    <template v-if="row.shipPlanShipments.length > 1">
                      <template v-for="(item,key) in row.shipPlanShipments">
                        <el-dropdown-item :key="key">
                          <span style="font-size: 12px">
                          {{ item.shipmentId + " | " + item.quantity }}
                        </span>
                        </el-dropdown-item>
                      </template>
                    </template>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
              <template v-else>-</template>
            </template>
          </template>
          <template v-slot:shipPlanTransfers="{ row }">
            <template v-if="!row.$gjParentData">
              <template v-if="row.shipPlanTransfers && row.shipPlanTransfers.length !== 0">
                <el-dropdown>
                 <span class="el-dropdown-link" style="font-size: 12px">
                    <span>{{
                        row.shipPlanTransfers[0] && row.shipPlanTransfers[0].transferCode
                      }} | {{ row.shipPlanTransfers[0] && row.shipPlanTransfers[0].quantity }}
                      <i class="el-icon-arrow-down el-icon--right" v-if="row.shipPlanTransfers.length > 1"></i></span>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <template v-if="row.shipPlanTransfers.length > 1">
                      <template v-for="(item,key) in row.shipPlanTransfers">
                        <el-dropdown-item :key="key">
                          <span style="font-size: 12px">
                          {{ item.transferCode + " | " + item.quantity }}
                        </span>
                        </el-dropdown-item>
                      </template>
                    </template>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
              <template v-else>-</template>
            </template>
          </template>
          <template v-slot:transportName="{row}">
            <template v-if="row.$gjChildData">
              {{ row.transportName | defaultShow }}-{{ row.prescription ? row.prescription + '天' : '' }}
            </template>
          </template>
          <template v-slot:purchaseCost="{row}">
            <template v-if="row.$gjChildData">
              <span>{{ row.purchaseCost ? '￥' + row.purchaseCost : '-' }}</span>
            </template>
          </template>
          <template v-slot:arriveCost="{row}">
            <template v-if="row.$gjChildData">
              <span>{{ row.arriveCost ? '￥' + row.arriveCost : '-' }}</span>
            </template>
          </template>
          <template v-slot:totalValue="{row}">
            <template v-if="row.$gjChildData">
              <span>{{ row.totalValue ? '￥' + row.totalValue : '-' }}</span>
            </template>
          </template>
          <template v-slot:memo="{ row }">
            <template v-if="row.$gjChildData">
              <gj-text width="90%">{{ row.memo | defaultShow }}</gj-text>
            </template>
          </template>
          <template v-slot:status="{row}">
            <template v-if="!row.$gjParentData">
              <gj-tag type="plain" style="margin-right: 10px" shape="rectangle"
                      :color="row.status | optionColor(statusOption.open)">
                {{ row.status | optionText(statusOption.open) }}
              </gj-tag>
            </template>
          </template>
          <template v-slot:op="{ row }">
            <template v-if="!row.$gjParentData">
              <gj-button-group
                  :show-length="1"
                  type="dropdown-op"
                  :config="opBtnConfig(row)"
              ></gj-button-group>
            </template>
          </template>
          <template v-slot:extend:row="{ row }">
            <div class="default">
              <div v-if="!row.expand">
                <gj-link type="default" @click="openDetail(row,true)">
                  <span>更多（共{{ row.num }}条）</span>
                  <i class="iconfont iconzhankai" style="font-size: 12px;"></i>
                </gj-link>
              </div>
              <div v-else>
                <gj-link type="default" @click="openDetail(row, false)">
                  <span style="width: 40px;">收起</span>
                  <i class="iconfont iconshouqi" style="font-size: 12px;"></i>
                </gj-link>
              </div>
            </div>
          </template>
        </gj-table>
      </template>
    </app-base-main>

    <delivery-plan-add v-if="addVisible" @goBack="goBack" :rows="propRows" :op-type="opType"
                       :type="type"></delivery-plan-add>

    <delivery-plan-detail v-if="showDetail" :id="openDetailId" @goBack="goBack"></delivery-plan-detail>

    <ship-plan-detail v-if="shipPlanVisible" :row="shipPlanRow" @goBack="goBack"></ship-plan-detail>

  </div>
</template>
<script>
import {
  isMeaningfulMixin, isMeaninglessMixin, queryMixin, selectionMixin, valueCheckMixin
} from "@/minxins";
import {deliveryPlanStatus, OpEnum} from "@/utils/options";
import {operateOptions, statusEnum as StatusEnum, statusOption} from './deliveryEnum'
import {FbaShipmentEnum} from "../../common/logistics/enum";
import {convertToDate, generateViewParams} from "@/utils/date.util";
import model from "./viewConfig";
import AppPrintLabelModal from "../fba-shipment/modal/print-label-modal.vue";
import AddFbaShipmentModal from "../../common/logistics/fba-shipment/modal/add/add-fba-shipment-modal";
import AppOpTransferOrderModal from "../../warehouse/transfer-order/modal/op/op-transfer-order-modal.vue";
import DeliveryPlanAdd from './modal/delivery-plan-add.vue'
import DeliveryPlanDetail from './modal/delivery-plan-detail'
import ShipPlanDetail from './modal/ship-plan-detail'
import OpPurchasePlanAddForDelivery from '@/views/modules/purchase/purchase-plan/modal/op-purchase-plan-add-for-delivery'
import {
  getDeliveryPlanList,
  postArraignmentDeliveryPlan,
  postReviewPass,
  getDeliveryMaxAssemblyQuantity,
  deleteShipPlan,
  postCompleteDeliveryPlan,
  postShipPlanGenerateShipment,
  postShipPlanGenerateTransfer,
  postShipPlanPurchasePlanQuery, postUpdateMemo, postShipPlanBatchEditQuery
} from '@/api/logistics'
import DeliveryPlanConfirm from "./modal/delivery-plan-confirm";
import {defaultVal, isMeaningful} from "@/utils/common";
import AppDeliveryPlanDesc from "./modal/delivery-plan-desc";
import {queryReviewSetting} from "@/api/purchase";
import {tagColors} from "@/components/tag/tag-colors"


export default {
  name: "delivery-plan",
  mixins: [queryMixin, selectionMixin, isMeaningfulMixin, isMeaninglessMixin, valueCheckMixin],
  components: {DeliveryPlanAdd, AppDeliveryPlanDesc, DeliveryPlanDetail, ShipPlanDetail},
  data() {
    return {
      timeStamp:null,
      tagColors,
      mainVisible: true,
      showDetail: false,
      batchOperate: null,
      openDetailId: '',
      addVisible: false,
      shipPlanVisible: false,
      shipPlanRow: null,
      reviewOption: false,
      groupType: 'planBatchCode',
      filter: {
        groupType: "planBatchCode",
        statuses: ['processing'],
        countryMarketValue: null,
        warehouseIds: [],
        date: {
          key: "created",
          value: [],
        },
        keyword: {
          key: "planBatchCode",
          value: "",
        },
        areCasesRequired: null,
        relationTransfer: null,
        relationShipment: null,
      },
      model,
      statusOption,
      StatusEnum,
      operateOptions,
      option: {
        deliveryPlanStatus,
      },
      type: null,
      btnLoading: {
        generateShipment: false,
        generateTransfer: false,
        generatePurchasePlan: false,
      },
      opType: null,
      keywordList: [
        {id: "planBatchCode", text: "计划批次号"},
        {id: "createUser", text: "创建人"},
        {id: "planCode", text: "计划编号", moreShow: true},
        {id: "productName", text: "产品名称"},
        {id: "sku", text: "SKU"},
        {id: "msku", text: "MSKU"},
        {id: "fnsku", text: "FNSKU"},
        {id: "transferCode", text: "调拨单号"},
        {id: "shipmentId", text: "FBA货件号"},
      ],
      bakSelectedRows: [],
      FbaShipmentEnum: FbaShipmentEnum,
      moduleName: "DELIVERY-PLAN",
      tableName: "deliveryPlan",
      tableData: [],
      maxTableDataVo: {
        maxAssemblyQuantity: null,
        voList: []
      },
      propRows: [],
      maxLoading: false,
      maxNumColumns: [
        {id: "picture", header: "图片", field: "picture:imageUrl", width: "50px", align: 'center', default: true,},
        {id: "skuName", header: "产品名称/SKU", field: "slot:skuName", minWidth: "160px", default: true,},
        {id: "requiredAmountPerUnit", header: "单位所需量", field: "requiredAmountPerUnit", width: "100px", default: true,},
        {id: "availableQuantity", header: "可用量", field: "availableQuantity", width: "90px", default: true,},
        {id: "alreadyOrderQuantity", header: "已下单", field: "alreadyOrderQuantity", width: "90px", default: true,},
        {id: "planWarehouseQuantity", header: "计划入库", field: "planWarehouseQuantity", width: "90px", default: true,},
      ],
      columns: [
        {id: "planBatchCode", header: "计划编号", field: "slot:code", width: "180px", default: true, disabled: true},
        {id: "picture", header: "图片", field: "picture:imageUrl", width: "50px", default: true, disabled: true},
        {id: "msku", header: "MSKU/FNSKU", field: "slot:msku", minWidth: "120px", default: true,},
        {id: "productName", header: "产品名称/SKU", field: "slot:productName", minWidth: "200px", default: true},
        {id: "countryCode", header: "店铺/国家", field: "slot:countryCode", minWidth: "120px", default: true,},
        {id: "singleQuantity", header: "单箱数量", field: "singleQuantity", width: "90px"},
        {id: "packageQuantity", header: "箱数", field: "packageQuantity", width: "90px"},
        {id: "shipedPlanQuantity", header: "计划发货量", field: "shipedPlanQuantity", width: "100px", default: true,},
        {
          id: "availableQuantity", header: "可用量/已下单/计划入库", field: "slot:availableQuantity",
          width: "160px", default: true,
        },
        {id: "difference", header: "差额", field: "difference", width: "120px", align: "right"},
        {id: "shipTime", header: "发货日期", field: "shipTime", minWidth: "120px", default: true,},
        {id: "transportName", header: "物流方式", field: "slot:transportName", minWidth: "120px", default: true,},
        {id: "warehouseId", header: "发货仓库", field: "warehouseName", minWidth: "120px", default: true,},
        {
          id: "areCasesRequired", header: "包装类型", field: "option:areCasesRequired",
          options: [{id: true, text: "原厂包装"}, {id: false, text: "混装"}], width: "90px", default: true,
        },
        {id: "shipPlanShipments", header: "FBA货件号|申报量", field: "slot:shipPlanShipments", minWidth: "200px"},
        {id: "shipPlanTransfers", header: "调拨单号|调拨量", field: "slot:shipPlanTransfers", minWidth: "200px"},
        {
          id: "purchaseCost",
          header: "采购成本（预估）",
          permission: 'cost:view',
          field: "slot:purchaseCost",
          minWidth: "120px"
        },
        {
          id: "arriveCost",
          header: "到库成本（预估）",
          permission: 'cost:view',
          field: "slot:arriveCost",
          minWidth: "120px"
        },
        {
          id: "totalValue",
          header: "总货值(预估)",
          permission: 'cost:view',
          field: "slot:totalValue",
          minWidth: "120px"
        },
        {id: "memo", header: "备注", field: "slot:memo", minWidth: "120px", default: true,},
        {id: 'status', header: '状态', field: 'slot:status', width: '80px', fixed: 'right', default: true},
        {id: "op", header: "操作", field: "slot:op", width: "110px", fixed: 'right', default: true}

      ],
      opBtnConfig: (row) => [
        {
          label: '编辑',
          show: () => this.$permission('shipPlan:add') && this.someIs(row.status, [StatusEnum.DRAFT, StatusEnum.REJECTED, StatusEnum.WAIT_HANDLE]),
          click: () => this.batchEdit([{...row}], 'one')
        },
        {
          label: '提审',
          show: () => this.$permission('shipPlan:add') && this.someIs(row.status, [StatusEnum.DRAFT, StatusEnum.REJECTED,]),
          click: () => this.pushReview([{...row}])
        },
        {
          label: '删除',
          show: () => this.$permission('shipPlan:add') && row.status === StatusEnum.DRAFT,
          click: () => this.batchDelete([{...row}])
        },
        {
          label: '审核通过',
          show: () => this.$permission('shipPlan:audit') && row.status === StatusEnum.WAIT_REVIEW,
          click: () => this.batchPass([{...row}])
        },
        {
          label: '审核驳回',
          show: () => this.$permission('shipPlan:audit') && row.status === StatusEnum.WAIT_REVIEW,
          click: () => this.batchReject([{...row}], StatusEnum.REJECTED)
        },
        {
          label: '作废',
          show: () => this.$permission('shipPlan:abolish') && this.someIs(row.status, [StatusEnum.WAIT_REVIEW, StatusEnum.REJECTED, StatusEnum.WAIT_HANDLE]),
          click: () => this.batchReject([{...row}], StatusEnum.ABOLISHED)
        },
        {
          label: '详情',
          show: () => true,
          click: () => this.shipPlanView(row)
        }
      ],
    };
  },
  activated(){
    // 再次进入已被缓存的此页时
    // 若路由中查询参数timeStamp变化时，则为从其他页面点击跳转至此，重新初始化查询参数
    if(this.$route.query.timeStamp!=this.timeStamp){
      this.timeStamp = this.$route.query.timeStamp;
      this.goBack();
      setTimeout(() => {
        this.add()
      }, 50)
    }
  },
  created() {
    if(this.$route.query.timeStamp!=this.timeStamp){
      this.timeStamp = this.$route.query.timeStamp
      this.goBack();
      setTimeout(() => {
        this.add()
      }, 50)
    }
    this.sort.prop = 'createTime';
    this.queryReviewOption();
  },
  computed: {
    selectable() {
      if (this.groupType === 'planBatchCode') {
        return (row) => !row.$gjExtendRow
      } else {
        return (row) => !row.$gjExtendRow && !row.$gjParentData;
      }
    },
  },

  methods: {
    $gjQuery() {
      this.selectedRows = [];
      this.clearBakRows();
      const params = {
        model: {
          groupType: this.groupType,
          statuses: this.filter.statuses,
          warehouseIds: this.filter.warehouseIds,
          areCasesRequired: this.filter.areCasesRequired,
          relationTransfer: this.filter.relationTransfer,
          relationShipment: this.filter.relationShipment,
        },
        ...this.queryPagination,
        ...this.querySort,
      };
      if (isMeaningful(this.filter.countryMarketValue)) {
        params.model.marketIds = this.filter.countryMarketValue.marketIds;
        params.model.countryCodes = this.filter.countryMarketValue.countryIds;
      }
      if (isMeaningful(this.filter.date.value)) {
        if (this.filter.date.key === 'created') {
          params.model.startCreateTime = convertToDate(this.filter.date.value[0]);
          params.model.endCreateTime = convertToDate(this.filter.date.value[1]);
        } else if (this.filter.date.key === 'deliver') {
          params.model.startShipTime = convertToDate(this.filter.date.value[0]);
          params.model.endShipTime = convertToDate(this.filter.date.value[1]);
        }
      }
      params.model[this.filter.keyword.key] = this.filter.keyword.value;
      delete params.model.keyword;
      delete params.model.date;
      delete params.model.$pageSize;
      this.loading = true;
      this.globalParams = params
      getDeliveryPlanList(params)
          .then((data) => {
            this.tableData = data.records.map((v, i) => {
              let parentKey = Math.floor(Math.random() * (999999 - 100000)) + 100000;
              v.childVisible = true;
              v.$gjParentKey = parentKey;
              const shipPlanList = this._.cloneDeep(v.shipPlanList) || [];
              shipPlanList.forEach(item => {
                item.currencySymbol = '￥';
                item.$gjChildKey = parentKey;
                item.$gjChildData = true;
              })
              return Object.assign(v, {
                productsCopy: shipPlanList,
                shipPlanList: shipPlanList.slice(0, 3),
                expand: false,
                dataIndex: i
              })
            });
            this.pagination = this.getPagination(data);
          }).complete(() => this.loading = false)
    },
    // 查询是否开启审批
    queryReviewOption() {
      queryReviewSetting({name: 'SHIP_PLAN_REVIEW_SETTING'}).then(res => {
        this.reviewOption = res;
      })
    },
    hidePopover() {
      document.body.click()
    },
    clearBakRows() {
      this.bakSelectedRows = [];
    },
    confirmEditMemo(val, row, closeEditor, closeLoading) {
      if (val && val.length <= 200) {
        this.confirmLoading = true;
        postUpdateMemo({
          id: row.planBatchId,
          memo: defaultVal(val, " "),
        }).then(() => {
          this.$gjMessage.success('操作成功');
          closeEditor();
          this.$gjResetPage();
        }).complete(() => closeLoading());
      } else {
        this.$gjMessage.error("请输入备注，且不能超过200个字符")
      }
    },
    // 获取 最大 可用量
    getMaxNums(sku, warehouseId) {
      this.maxTableDataVo = {
        maxAssemblyQuantity: null,
        voList: []
      }
      this.maxLoading = true;
      getDeliveryMaxAssemblyQuantity(sku, warehouseId).then(res => {
        if (isMeaningful(res)) this.maxTableDataVo = res;
      }).complete(() => this.maxLoading = false)
    },
    shipPlanView(row) {
      this.mainVisible = false;
      this.shipPlanVisible = true;
      this.shipPlanRow = row;
    },
    // 生成采购计划
    addPurchasePlan() {
      let rows = this.selectedRows;
      if (rows.length === 0) {
        this.$gjMessage.warning("请勾选需要操作的数据");
        return false;
      }
      if (this.selectedSomeIsNot('status', StatusEnum.WAIT_HANDLE)) {
        this.$gjMessage.warning("只有待处理状态的才能生成采购计划");
        return false;
      }
      this.btnLoading.generatePurchasePlan = true;
      this.propRows = [];
      postShipPlanPurchasePlanQuery({idList: rows.map(item => item.id)}).then(res => {
        if (res && res.length > 0) {
          const modal = this.$gjCreate(OpPurchasePlanAddForDelivery, {
            props: {
              opType: 0,
              delivery: true,
              deliveryList: res,
              appendHeight: 80,
            },
            on: {
              closeOpen: (res) => {
                this.goBack(res);
                modal.$gjDestroy();
              },
            },
          });
        }
      }).complete(() => this.btnLoading.generatePurchasePlan = false)

    },
    goBack(val) {
      if (val === 'refresh') {
        this.$gjNoticeQuery();
        this.mainVisible = false;
      }
      setTimeout(() => {
        this.mainVisible = true;
      }, 50)
      this.addVisible = false;
      this.showDetail = false
      this.shipPlanVisible = false;
      this.purchaseVisible = false;

    },
    // 切换分组
    changeGroup(key) {
      this.filter.groupType = key;
      this.groupType = key;
      this.sort.prop = key === 'marketId' ? 'marketId' : 'createTime';
      if (this.groupType === 'planBatchCode') this.extendObj = {prop: 'extendRow'};
      this.$gjQuery();
    },
    // 打印标签
    printLabel() {
      let rows = this.selectedRows;
      if (rows.length === 0) {
        this.$gjMessage.warning("请勾选需要操作的数据");
        return false;
      }
      this.$gjCreate(AppPrintLabelModal, {
        props: {
          ids: [],
          deliveryPlan: rows,
        },
        on: {
          created: () => {
            this.$gjResetPage();
          },
        },
      });
    },
    $gjQueryInitParams() {
      return {
        filter: {
          groupType: "planBatchCode",
          statuses: ['processing'],
          countryMarketValue: null,
          warehouseIds: [],
          date: {
            key: "created",
            value: [],
          },
          keyword: {
            key: "planBatchCode",
            value: "",
          },
          areCasesRequired: null,
          relationTransfer: null,
          relationShipment: null,
        }
      }
    },
    // 创建货件
    addPackage() {
      let rows = this.selectedRows;
      if (rows.length === 0) {
        this.$gjMessage.warning("请勾选需要操作的数据");
        return false;
      }
      if (this.selectedSomeIsNot('status', StatusEnum.WAIT_HANDLE)) {
        this.$gjMessage.warning("只有待处理状态的才能创建货件");
        return false;
      }
      this.btnLoading.generateShipment = true;
      postShipPlanGenerateShipment({idList: rows.map(item => item.id)}).then(data => {
        this.$gjCreate(AddFbaShipmentModal, {
          props: {
            deliveryPlan: data,
          },
          on: {
            created: () => {
              this.$gjResetPage();
            },
          },
        });
      }).complete(() => this.btnLoading.generateShipment = false)
    },
    // 生成调拨单
    addTransferSlip() {
      let rows = this.selectedRows;
      if (rows.length === 0) {
        this.$gjMessage.warning("请勾选需要操作的数据");
        return false;
      }
      if (this.selectedSomeIsNot('status', StatusEnum.WAIT_HANDLE)) {
        this.$gjMessage.warning("只有待处理状态的才能生成调拨单");
        return false;
      }
      this.btnLoading.generateTransfer = true;
      postShipPlanGenerateTransfer({idList: rows.map(item => item.id)}).then(res => {
        this.$gjCreate(AppOpTransferOrderModal, {
          props: {
            deliveryPlan: res,
            opType: OpEnum.type.ADD,
            header: "添加调拨单",
          },
          on: {
            created: () => {
              this.$gjResetPage();
            },
          },
        })
      }).complete(() => this.btnLoading.generateTransfer = false);
    },
    openAll(row, flag) {
      if (flag) {
        row.shipPlanList = row.productsCopy.slice(0, 3);
        if (row.productsCopy.length > 2) {
          row.extendRow = true;
        }
      } else {
        row.shipPlanList = [];
        row.extendRow = false;
      }
      this.tableData = this.tableData.map((v) => {
        if (v.marketId === row.marketId) {
          v.expand = false;
          v.shipPlanList = row.shipPlanList;
        }
        return v;
      });
      row.childVisible = flag;
      this.bakSelectedRows = this._.cloneDeep(this.selectedRows);
    },
    openDetail(row, flag) {
      if (flag) {
        row.shipPlanList = row.productsCopy;
        row.expand = flag;
      } else {
        row.shipPlanList = row.shipPlanList.slice(0, 3);
        row.expand = flag;
      }
      this.tableData = this.tableData.map((v) => {
        if (this.groupType === 'planBatchCode') {
          if (v.planBatchId === row.planBatchId) {
            v.expand = row.expand;
            v.shipPlanList = row.shipPlanList;
          }
        } else {
          if (v.marketId === row.marketId) {
            v.expand = row.expand;
            v.shipPlanList = row.shipPlanList;
          }
        }
        return v;
      });
      this.bakSelectedRows = this._.cloneDeep(this.selectedRows);
    },
    add() {
      this.propRows = [];
      this.opType = OpEnum.type.ADD;
      this.mainVisible = false;
      this.addVisible = true;
    },
    batchEdit(rows, type) {
      this.type = type;
      this.queryEditData(rows);
    },
    queryEditData(idList) {
      let ids = idList.map(item => item.id)
      postShipPlanBatchEditQuery({idList: ids}).then(res => {
        if (res && res.length > 0) {
          this.propRows = [];
          this.mainVisible = false;
          this.addVisible = true;
          this.opType = OpEnum.type.UPDATE;
          this.propRows = idList;
        }
      })
    },
    changeOperate() {
      this.selectedRows = this.selectedRows.filter(item => item.$gjChildData)
      if (this.selectedRows.length === 0) {
        this.$nextTick(() => {
          this.batchOperate = null;
        })
        this.$gjMessage.warning("请勾选需要操作的发货计划！");
        return false;
      }
      if (this.batchOperate === 'edit') {
        this.$nextTick(() => {
          this.batchOperate = null;
        })
        if (this.selectedSomeNotIn('status', [StatusEnum.REJECTED, StatusEnum.DRAFT, StatusEnum.WAIT_HANDLE])) {
          this.$gjMessage.warning("草稿、已驳回、待处理状态下的发货计划才能编辑！")
          return false;
        }
        this.batchEdit(this.selectedRows, 'batch');
      } else if (this.batchOperate === 'pushReview') {
        this.$nextTick(() => {
          this.batchOperate = null;
        })
        if (this.selectedSomeNotIn('status', [StatusEnum.REJECTED, StatusEnum.DRAFT])) {
          this.$gjMessage.warning("草稿、已驳回状态下的发货计划才能提审！")
          return false;
        }
        this.pushReview(this.selectedRows);
      } else if (this.batchOperate === 'pass') {
        this.$nextTick(() => {
          this.batchOperate = null;
        })
        if (this.selectedSomeIsNot('status', StatusEnum.WAIT_REVIEW)) {
          this.$gjMessage.warning("待审核状态下的发货计划才能审核!")
          return false;
        }
        this.batchPass(this.selectedRows);
      } else if (this.batchOperate === 'reject') {
        this.$nextTick(() => {
          this.batchOperate = null;
        })
        if (this.selectedSomeIsNot('status', StatusEnum.WAIT_REVIEW)) {
          this.$gjMessage.warning("待审核状态下的发货计划才能审核!")
          return false;
        }
        this.batchReject(this.selectedRows, StatusEnum.REJECTED);
      } else if (this.batchOperate === 'invalid') {
        this.$nextTick(() => {
          this.batchOperate = null;
        })
        if (this.selectedSomeNotIn('status', [StatusEnum.WAIT_REVIEW, StatusEnum.REJECTED, StatusEnum.WAIT_HANDLE])) {
          this.$gjMessage.warning("待审核、已驳回、待处理状态的发货计划才能作废!")
          return false;
        }
        this.batchReject(this.selectedRows, StatusEnum.ABOLISHED);
      } else if (this.batchOperate === 'del') {
        if (this.selectedSomeIsNot('status', StatusEnum.DRAFT)) {
          this.$nextTick(() => {
            this.batchOperate = null;
          })
          this.$gjMessage.warning("草稿状态的发货计划才能删除!")
          return false;
        }
        this.batchDelete(this.selectedRows);
      } else if (this.batchOperate === 'copy') {
        this.$nextTick(() => {
          this.batchOperate = null;
        })
        this.batchCopy(this.selectedRows)
      } else if (this.batchOperate === 'complete') {
        this.$nextTick(() => {
          this.batchOperate = null;
        })
        if (this.selectedSomeNotIn('status', [StatusEnum.WAIT_HANDLE])) {
          this.$gjMessage.warning('待处理状态的发货计划才能标记完成！')
          return false;
        }
        this.batchComplete(this.selectedRows)
      }
    },

    // 复制发货计划
    batchCopy() {
      this.propRows = [];
      if (this.selectedRows.length > 1) {
        let checkStr = this.selectedRows[0].countryCode + this.selectedRows[0].marketId + this.selectedRows[0].areCasesRequired;
        let find = this.selectedRows.filter(item => (item.countryCode + item.marketId + item.areCasesRequired) !== checkStr);
        if (find.length > 0) {
          this.$gjMessage.warning("店铺/国家、包装类型相同的发货计划支持批量复制");
          return false;
        }
      }
      this.addVisible = true;
      this.opType = OpEnum.type.ADD;
      this.mainVisible = false;
      this.propRows = this.selectedRows;
    },
    /**
     * 标记完成
     */
    batchComplete(selectedRows = []) {
      if (selectedRows && selectedRows.length) {
        postCompleteDeliveryPlan({
          idList: selectedRows.map(v => v.id)
        }).then(() => {
          this.$gjMessage.success('操作成功');
          this.$gjResetPage();
        })
      }
    },
    generateViewParams,
    // 提审
    pushReview(rows) {
      this.loading = true;
      postArraignmentDeliveryPlan({
        idList: rows.map(e => e.id),
      })
          .then(() => {
            this.$gjMessage.success('操作成功');
            this.$gjResetPage();
          })
    },
    batchDelete(rows) {
      const modal = this.$gjCreate('gj-info-modal', {
        props: {
          title: '删除确认',
          content: rows.length === 1
              ? `是否要删除发货计划，删除后无法恢复？`
              : `已选中 ${rows.length} 个发货计划，是否要删除发货计划，删除后无法恢复？`,
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm: () => {
            modal.confirmLoading = true;
            deleteShipPlan({idList: rows.map(v => v.id)})
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                }).complete(() => modal.confirmLoading = false)
          }
        }
      });
    },
    batchPass(rows) {
      const modal = this.$gjCreate('gj-info-modal', {
        props: {
          title: '审核确认',
          content: rows.length === 1
              ? `是否通过审核？`
              : `已选中 ${rows.length} 个发货计划，是否批量是否通过审核？`,
        },
        on: {
          cancel: () => modal.$gjDestroy(),
          confirm: () => {
            modal.confirmLoading = true;
            postReviewPass({idList: rows.map(v => v.id)})
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                }).complete(() => modal.confirmLoading = false)
          }
        }
      });
    },
    batchReject(rows = [], type) {
      let title = type === 'rejected' ? '驳回' : '作废';
      let label = type === 'rejected' ? '驳回理由' : '作废理由';
      this.$gjCreate(DeliveryPlanConfirm, {
        props: {title, label, rows, type},
        on: {
          updated: () => {
            this.$gjMessage.success('操作成功');
            this.$gjResetPage();
          }
        },
      });
    },
    /**
     * 批次详情
     * @param row
     */
    openLog(row) {
      this.openDetailId = row.planBatchId
      if (this.openDetailId) {
        this.showDetail = true
      }
    },
  },
};
</script>
<style scoped lang="scss">
.iconfont {
  font-size: 10px;
  color: #999;
}

.iconshouqi {
  margin-left: 5px;
}

.baseCon {
  display: flex;
  justify-content: right;
}

.maxNum {
  font-size: 12px;
  color: #969696;
  // line-height: 20px;
  font-weight: 400;
  margin-bottom: 12px;
}

.type-text {
  display: inline-block;
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  color: #1F6EEF;
  width: 20px;
  height: 20px;
  background: #EFF5FF;
  border-radius: 2px;
}

.gj-group {
  padding: 0 10px;
  cursor: pointer;
}

.gj-group:hover {
  color: #1F6EEF;
}

.group-active {
  color: #1F6EEF;
}

.title-span {
  color: #999999;
}

/deep/ .gj-dialog-plan {
  .purchase-plan {
    padding: 0;
  }

  .el-dialog__header {
    padding: 0;
    padding-bottom: 12px;
  }

  .el-dialog__body {
    padding: 0 0 16px 0;
  }

  .content-cell {
    padding: 0;
  }

  .base-content {
    padding: 0 20px;
  }

  .header {
    margin-bottom: 28px;
  }

  .el-dialog__headerbtn {
    top: 15px;
  }

  .op-purchase_line {
    height: 1px;
    width: 100%;
    background: #E4E5E6;
    position: absolute;
    top: 42px;
  }
}

.selected-active {
  /deep/ .el-input__inner {
    &::placeholder {
      color: #333333;
    }
  }
}

/deep/ .gj-tag--oval {
  margin-left: 4px;
}

/deep/ .el-link.el-link--default:hover {
  .iconfont {
    color: inherit;
  }
}
</style>
